import { render } from "./list-content.vue?vue&type=template&id=4ff864ce&ts=true"
import script from "./list-content.vue?vue&type=script&lang=ts"
export * from "./list-content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__